import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from "gatsby";
import { OutboundLink } from "gatsby-plugin-gtag";
import { EuiSpacer } from "@elastic/eui";
import DangerBox from "components/Outdoor_Cameras/IN-9820_QFHD/Camera_Reset/DangerBox";
import SuccessBox from "components/Outdoor_Cameras/IN-9820_QFHD/Camera_Reset/PrimaryBox";
import NavButtons from "components/Outdoor_Cameras/IN-9820_QFHD/NavButtons";
import BreadCrumbs from "components/Layout/BreadCrumbs";
import SEOHelmet from "components/Layout/SEOHelmet";
export const _frontmatter = {
  "title": "INSTAR HD Kamera Hardware Reset",
  "path": "/Aussenkameras/IN-9820_QFHD/Kamera_Reset/",
  "dateChanged": "2018-01-22",
  "author": "Mike Polinowski",
  "excerpt": "INSTAR IN-9820 4K (QFHD) Outdoor IP Kamera Werkseinstellung",
  "image": "./P_SearchThumb_IN-9008HD_Reset.png",
  "social": "/images/Search/P_SearchThumb_IN-9820QFHD_Reset.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_P-IN-9008HD_white.webp",
  "chapter": "Outdoor Cameras"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <SEOHelmet title="INSTAR HD Kamera Hardware Reset" dateChanged="2018-01-22" author="Mike Polinowski" tag="INSTAR IP Camera" description="INSTAR IN-9820 4K (QFHD) Outdoor IP Kamera Werkseinstellung" image="/images/Search/P_SearchThumb_IN-9420HD_Reset.png" twitter="/images/Search/P_SearchThumb_IN-9420HD_Reset.webp" location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN="/en/Outdoor_Cameras/IN-9820_QFHD/Camera_Reset/" locationFR="/fr/Outdoor_Cameras/IN-9820_QFHD/Camera_Reset/" crumbLabel="Reset" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <h2 {...{
      "id": "wiederherstellen-der-werkseinstellungen-ihrer-kamera",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#wiederherstellen-der-werkseinstellungen-ihrer-kamera",
        "aria-label": "wiederherstellen der werkseinstellungen ihrer kamera permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Wiederherstellen der Werkseinstellungen Ihrer Kamera`}</h2>
    <p>{`Um die Kamera auf Werkseinstellungen zurückzusetzen, halten Sie den Resetknopf für 20 Sekunden gedrückt. (siehe Abb.1) Nach dem Zurücksetzen macht die Kamera einen Neustart, was bis zu 60
Sekunden dauern kann. Da nach einem Reset alle Daten zurückgesetzt werden, ist es notwendig die Kamera neu einzurichten:`}</p>
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/1d7ee629eb870a9495d9d7fcab88f1a6/4b2cc/IN-9420-reset_01.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "66.08695652173914%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAA7rAAAO6wFxzYGVAAAA90lEQVQoz5WSW0/EIBCF9///OX1p1Idqt6GXbdrCcCswZTAWXaub6PbkPBDIx5kZOKU75L1HROecUoqIrvunf8l1XbuuAwBjDACEEA7A3vsQAiJqrYUQB+B1U14jIuc8xnggeRzHaZNSSmu9P/oLzrNpmqYoivP5bK11zl0LuSsZEeu6HoaBiHL/B+CUUowxV5Ef7Bi8v8Va+xumL98KADjnSqllWYwx3vsdTJS8T859ejePrLIsGWN93zPGEPHntEOwXVe9PD89PE6vb2maCSQJyI4C6qqSUgoh9t1+Jy/jKNtW9RfVtB9VEKUYs2n7ElLKeZ5v+XekAfylvEz2ZgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/1d7ee629eb870a9495d9d7fcab88f1a6/e4706/IN-9420-reset_01.avif 230w", "/de/static/1d7ee629eb870a9495d9d7fcab88f1a6/d1af7/IN-9420-reset_01.avif 460w", "/de/static/1d7ee629eb870a9495d9d7fcab88f1a6/7f308/IN-9420-reset_01.avif 920w", "/de/static/1d7ee629eb870a9495d9d7fcab88f1a6/1b9e6/IN-9420-reset_01.avif 1013w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/1d7ee629eb870a9495d9d7fcab88f1a6/a0b58/IN-9420-reset_01.webp 230w", "/de/static/1d7ee629eb870a9495d9d7fcab88f1a6/bc10c/IN-9420-reset_01.webp 460w", "/de/static/1d7ee629eb870a9495d9d7fcab88f1a6/966d8/IN-9420-reset_01.webp 920w", "/de/static/1d7ee629eb870a9495d9d7fcab88f1a6/d5002/IN-9420-reset_01.webp 1013w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/1d7ee629eb870a9495d9d7fcab88f1a6/81c8e/IN-9420-reset_01.png 230w", "/de/static/1d7ee629eb870a9495d9d7fcab88f1a6/08a84/IN-9420-reset_01.png 460w", "/de/static/1d7ee629eb870a9495d9d7fcab88f1a6/c0255/IN-9420-reset_01.png 920w", "/de/static/1d7ee629eb870a9495d9d7fcab88f1a6/4b2cc/IN-9420-reset_01.png 1013w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/1d7ee629eb870a9495d9d7fcab88f1a6/c0255/IN-9420-reset_01.png",
              "alt": "INSTAR HD Kamera Hardware Reset",
              "title": "INSTAR HD Kamera Hardware Reset",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "über-die-weboberfläche-ihrer-kamera",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#%C3%BCber-die-weboberfl%C3%A4che-ihrer-kamera",
        "aria-label": "über die weboberfläche ihrer kamera permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Über die Weboberfläche Ihrer Kamera`}</h3>
    <p>{`Wenn Sie noch Zugriff auf Ihre Kamera über Ihren Webbrowser haben, können Sie die `}<Link to="/Web_User_Interface/1440p_Serie/System/Werksreset/" mdxType="Link">{`Webinterface zum Zurücksetzen Ihrer Kamera`}</Link>{`.`}</p>
    <EuiSpacer mdxType="EuiSpacer" />
    <DangerBox mdxType="DangerBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "über-die-hardware-reset-taste",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#%C3%BCber-die-hardware-reset-taste",
        "aria-label": "über die hardware reset taste permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Über die Hardware-Reset-Taste`}</h3>
    <p>{`Um den Reset durchzuführen, halten Sie die Reset-Taste `}<strong parentName="p">{`15 Sekunden lang`}</strong>{` (s.u.) gedrückt, während die Kamera über das Netzteil mit Strom versorgt wird und das LAN-Kabel entfernt wurde.`}</p>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    {
      /*
      ### Über die SD-Karte
      Wenn Sie keinen Zugriff mehr auf das Webinterface haben und der Reset-Button beschädigt ist, haben Sie den Reset noch auf der SD-Karte Ihrer Kamera. Legen Sie dafür eine Datei an und geben Sie ihr den Namen **reset** (ganz wichtig **ohne Dateiendung**!) - unter Windows ist das nicht so einfach, daher haben wir die notwendige Datei <OutboundLink href="https://wiki.instar.com/dl/IN-9008HD/wps_reset.zip">hier zum Download</OutboundLink>. Die Datei ist gepackt und muss erst aus dem Zip-Container befreit werden, bevor wir sie verwenden können.
      #### Zurücksetzen der Kamera
      **Zurücksetzen** : Entnehmen Sie die SD-Karte aus der Kamera und schließen Sie sie über ein Kartenlesegerät an Ihren Computer an. Legen Sie dann die Datei im **root Verzeichnis** (d.h. direkt auf der Karte, nicht in einem Unterordner) der Speicherkarte ab und werfen Sie dann die SD-Karte aus. Um die Kamera wieder auf die Werkseinstellungen zurückzusetzen, setzen Sie die SD-Karte wieder in den Kartensteckplatz der Kamera ein und starten Sie die Kamera anschließend neu.
      ![INSTAR HD Kamera Hardware Reset](./reset_wps_by_sd_card.png)
      <EuiSpacer />
      */
    }
    <h4 {...{
      "id": "wlan-integration-nach-dem-zurücksetzen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#wlan-integration-nach-dem-zur%C3%BCcksetzen",
        "aria-label": "wlan integration nach dem zurücksetzen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`WLAN-Integration nach dem Zurücksetzen`}</h4>
    <p><strong parentName="p">{`WPS`}</strong>{` : Um die Kamera nach dem Neustart wieder mit dem WLAN-Netzwerk zu verbinden, kann man eine Datei namens `}<strong parentName="p">{`wps`}</strong>{` (ganz wichtig `}<strong parentName="p">{`ohne Dateiendung`}</strong>{`!) erstellen - unter Windows ist das nicht so einfach, daher haben wir die notwendige Datei `}<OutboundLink href="https://wiki.instar.com/dl/IN-9008HD/wps_reset.zip" mdxType="OutboundLink">{`hier zum Download bereitgestellt`}</OutboundLink>{`. Die Datei ist gepackt und muss erst aus dem Zip-Container befreit werden, bevor wir sie verwenden können. Legen Sie diese Datei im `}<strong parentName="p">{`root Verzeichnis`}</strong>{` (d.h. direkt auf der Karte, nicht in einem Unterordner) der Speicherkarte ab und stecken Sie sie dann wieder in den Kartenslot Ihrer Kamera. Starten Sie dann den `}<Link to="/Schnell_Installation/Herstellen_der_WLAN_Verbindung/WPS_Plug_and_Play/" mdxType="Link">{`WPS-Modus Ihres WLAN-Routers`}</Link>{` und starten Sie die Kamera neu. Nach dem Neustart befindet sich die Kamera im WPS-Modus und versucht, sich mit Ihrem Router zu verbinden.`}</p>
    <h4 {...{
      "id": "wo-finde-ich-die-sd-karte-der-kamera",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#wo-finde-ich-die-sd-karte-der-kamera",
        "aria-label": "wo finde ich die sd karte der kamera permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Wo finde ich die SD Karte der Kamera`}</h4>
    <p>{`Öffnen Sie die kleine Klappe auf der Rückseite des Kamerakopfes und entfernen Sie die MicroSD-Karte mit Ihrer Pinzette aus dem Kartenleser:`}</p>
    <p><img parentName="p" {...{
        "src": "./IN-9820_QFHD_SD_Card.jpg",
        "alt": "INSTAR IN-9420 FHD Kamera Werksreset"
      }}></img></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      